<template>
    <div id="app">
        <div class="container">
            <div class="row">
                <div class="col-md-6 offset-md-3 col-12 main">
                    <div class="row">
                        <div v-if="this.origin === 'ecommerce_bank'" class="col-12 main-logo">
                            <a href="https://pyxpay.com.py" target="_blank"><img src="./../assets/logo.png"></a>
                        </div>
                        <div v-if="this.origin === 'pyxpay_usa'" class="col-12 main-logo">
                            <a href="https://pyxpayment.com/" target="_blank"><img src="./assets/pyxpay_usa_logo.png"></a>
                        </div>
                        <div class="col-12 first-text">
                            {{ getLocale("pixPaymentTo") }} {{ response.nomeEstabelecimento }}
                        </div>
                        <div class="col-12 first-text value">
                            {{
                                new Intl.NumberFormat('pt-BR',
                                        {
                                            style: 'currency', currency: 'BRL'
                                        }
                                ).format(response.valor)
                            }}
                        </div>
                        <div v-if="error" class="col-md-6 offset-md-3 col-12 main">
                            <p class="text-danger">{{ error }}</p>
                        </div>
                        <div class="col-12 qr" v-if="isLoading && !error">
                            <img src="./assets/load.gif">
                        </div>
                        <div class="col-12 qr" v-if="!isLoading && !error">
                            <vue-qrcode :scale="8" :value="response.pixChave"/>
                        </div>
                        <div class="col-md-8 col-12 offset-md-2" v-if="!isLoading && !error">
                            <button @click.prevent="copyText()" class="btn-block btn-info btn mb-2" type="button"
                                    id="button-addon2">{{ getLocale("copy") }}
                            </button>
                            <p class="text-success" v-if="copied">{{ getLocale("copySuccess") }}</p>
                            <textarea rows="8" ref="copyInput" class="form-control user-select-all">{{response.pixChave}}</textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import VueQrcode from 'vue-qrcode';
import axios from 'axios'

export default {
    name: "super",
    components: {VueQrcode},
    data() {
        return {
            baseUrl: "https://pyxpay.com.br/sistema/api/transacao/pix",
            origin: "ecommerce_bank",
            error: false,
            copied: false,
            id: 0,
            isLoading: true,
            response: {
                valor: 0,
                pixChave: "",
                nomeCliente: "",
                nomeEstabelecimento: ""
            }
        }
    },
    created() {
        const vm = this;

        const params = new URLSearchParams(window.location.search);
        const queryParams = {};

        params.forEach((value, key) => {
            queryParams[key] = value;
        });
        console.log(queryParams)

        vm.origin = queryParams.origin ?? "ecommerce_bank";

        if (vm.origin !== "ecommerce_bank") {
            vm.origin = "pyxpay_usa";
            vm.baseUrl = "https://pyxpayment.com/sistema/api/transacao/pix"
        }

        this.id = queryParams.id || this.$route.params.id;
        console.log(this.$route.params.id)

        axios.get(`${this.baseUrl}/${this.id}`).then(function (data) {
            vm.response = data.data;
            vm.isLoading = false;
            vm.error = false;
        })
            .catch(function (e) {
                if (e.response.status === 404) {
                    vm.error = vm.getLocale("pixNotFound");
                }
                if (e.response.status === 422) {
                    vm.error = (e.response.data.message);
                }
            })
    },
    methods: {
        getLocale(code){
            const arr = {
                "ecommerce_bank": {
                    "pixPaymentTo": "Pagar com PIX para",
                    "copy": "Copiar",
                    "copySuccess": "Link de pagamento copiado com sucesso",
                    "pixNotFound": "Pix não encontrado"
                },
                "pyxpay_usa": {
                    "pixPaymentTo": "Pix Payment to",
                    "copy": "Copy",
                    "copySuccess": "Payment link copied successfully",
                    "pixNotFound": "Pix not found"
                }
            };

            return arr[this.origin][code];
        },
        copyText() {
            let copyInput = this.$refs.copyInput;
            copyInput.removeAttribute('disabled')
            copyInput.select();
            try {
                document.execCommand('copy');
            } catch (err) {
                alert("Não foi possivel copiar")
            }
            copyInput.setAttribute('disabled', 'true')
            window.getSelection().removeAllRanges()
            this.copied = true;
        },
    }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');
$mobile-break: 600px;
body {
    background-color: rgba(244, 245, 247)
}

#app {
    .main {
        margin-top: 80px;
        text-align: center;
        margin-bottom: 40px;

        @media only screen and (max-width: $mobile-break) {
            margin-top: 20px;
        }

        .main-logo {
            text-align: center;
            margin-bottom: 5px;
            @media only screen and (max-width: $mobile-break) {
                margin-top: 0;
            }

            img {
                max-width: 100%;
                height: 64px;
                @media only screen and (max-width: $mobile-break) {
                    height: 48px;
                }
            }
        }

        .first-text {
            font-family: 'Lato', serif;
            font-size: 24px;
            font-weight: 700;
            @media only screen and (max-width: $mobile-break) {
                font-size: 18px;
            }

            &.value{
                color: #088408;
            }
        }

        .qr {
            padding: 20px 0;

            @media only screen and (max-width: $mobile-break) {
                padding: 20px 40px;
            }

            img {
                max-width: 100%;
            }
        }
    }

    .powered {
        margin-bottom: 25px;

        .text {
            font-weight: bold;
            font-size: 0.8em;
            text-align: center;
            color: #b7b2b2;
            margin-top: 10px;
        }

        .img {
            text-align: center;

            img {
                width: 75px;
                @media only screen and (max-width: $mobile-break) {
                    width: 48px;
                }
            }
        }

    }
}
</style>
